'use client';
import React from 'react';
import GardeniaContainer from '@components-launch/Gardenia-Bay/GardeniaContainer';
import cn from './style.module.scss';

export default function WelcomeLifestyle(props: any) {
  const { t } = props;
  return (
    <div
      className={cn.lifestyleGRDWrapper}
      style={{
        backgroundImage: `url(${props.lifeStyleBannerImg.url})`,
      }}
    >
      <div className={cn.lifestyleGRDStory}>
        <GardeniaContainer>
          <div className={cn.lifestyleGRDContent}>
            <div className={cn.lifestyleGRDContent__element}>
              <h2>{t['yasLifestyleHeading']}</h2>
              <p>{t['yasLifestyleContent']}</p>
            </div>
          </div>
        </GardeniaContainer>
      </div>
    </div>
  );
}
